// Guest token utility for Pay & Scratch flow.
// A stable, browser-scoped token that ties anonymous payments/scratch cards to a
// device. When the guest signs in or registers, this token is used to link all
// past payments/rewards to the member account (see MemberContext._claimGuest).

const KEY = "pp_guest_token";

function _rand() {
  try {
    if (typeof crypto !== "undefined" && crypto.getRandomValues) {
      const arr = new Uint8Array(16);
      crypto.getRandomValues(arr);
      return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
    }
  } catch { /* ignore */ }
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
}

export function getGuestToken() {
  let t = null;
  try { t = localStorage.getItem(KEY); } catch { /* ignore */ }
  if (!t) {
    t = _rand();
    try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
  }
  return t;
}

export function clearGuestToken() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
